import Relay from 'react-relay/classic';
import RelayGraphQLMutation from 'react-relay/lib/RelayGraphQLMutation';
import { courseFrag, userFrag } from './Queries';

export default class AddQuestionSubmissionMutation {
  constructor(props) {
    this.props = props;
  }

  assignQuery = Relay.QL`
    fragment on AddQuestionSubmissionPayload {
      course {
        ${courseFrag}
      }
      user {
        ${userFrag}
      }
      curriculum {
        assignInfoCurriculum {
          assignedBy {
            pid
            name
            picture
          }
        }
        curriculumPerformance {
          isRequired
        }
      }
    }
  `;

  submissionQuery = Relay.QL`
    fragment on AddQuestionSubmissionPayload {
      card {
        pid
        type
        duration
        contributeToSuccessStatus
        questionsForReview {
          minReviewCount
          currentReviewCount
        }
        questionAnswers(userId: $userId) {
          pid
          q
          rType
          rTypeSecondary
          rawScore
          minScore
          maxScore
          gradingScheme
          peerQuestions(userId: $userId) {
            question
            reviewsReceived {
              reviewedBy {
                pid
              }
            }
          }
          options{
            text
            correct
          }
          topRatedResponses {
            answer {
              response
              answerType
            }
            user {
              name
              picture
            }
          }
          answer{
            pid
            evaluatedAnswer
            response
            lastUpdatedResponse
            thumbUrl
            answerType
            feedback
            gradedBy {
              pid
              name
              picture
            }
            feedbackGivenBy {
              pid
              name
              picture
            }
          }
        }
        resource {
          type
          content {
            questions {
              rType
            }
          }
          narrationUrl
        }
        hideMarkComplete
        maxScore
        performance(userId: $userId) {
          completionStatus
          timeSpent
          successStatus
          reAttemptCount
          actualSubmit
          progressMeasure
          rawScore
          forceComplete
          scaledProgressMeasure
          scorm{
            score_raw
            mastery_score
            scormData
          }
        }
        resource {
          type
          content {
            data
            url
            thumbUrl
          }
          narrationUrl
        }
      }
      course {
        pid
        coursePerformance{
          visibleCompleted
          timeSpent
          scaledProgressMeasure
          completionStatus
          successStatus
        }
      }
    }
  `;

  commit(callbacks) {
    const isAssigned = !!this.props.coursePerformanceId;

    const query = Relay.QL`
      mutation AddQuestionSubmission($input_0: AddQuestionSubmissionInput!) {
        addQuestionSubmission(input: $input) {
          ${isAssigned ? this.submissionQuery : this.assignQuery}
          clientMutationId
        }
      }
    `;
    const variables = {
      userId: this.props.userId,
      input: {
        rootOfferId: this.props.rootOfferId,
        userId: this.props.userId,
        cardId: this.props.cardId,
        answerArray: this.props.answerArray,
        actualSubmit: this.props.actualSubmit
        // pathId: this.props.pathId
      }
    };

    const mutation = new RelayGraphQLMutation(query, variables, null, Relay.Store, callbacks);

    const config = [{ type: 'FIELDS_CHANGE' }];
    if (!this.props.coursePerformanceId) {
      config[0].fieldIDs = {
        course: this.props.courseGraphId,
        user: this.props.userGraphId
        // curriculum: this.props.pathGraphId,
      };
    } else {
      config[0].fieldIDs = {
        card: this.props.mainId,
        course: this.props.courseGraphId
        // curriculum: this.props.pathGraphId,
      };
    }
    // console.log(mutation);
    mutation.commit(config);
  }
}
